"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonField = void 0;
class PersonField {
    constructor({ name, type = "string", title = undefined, icon = undefined, tooltip = undefined, format = undefined, readOnly = false, canMapFrom = true, firstClassField = true, array = false, createdBy = undefined, enumNames = undefined, enum: enums = undefined, allowNewEnumValues = undefined, displayType = undefined, }) {
        this.name = name;
        this.type = type;
        if (title)
            this.title = title;
        if (icon)
            this.icon = icon;
        if (tooltip)
            this.tooltip = tooltip;
        if (format)
            this.format = format;
        this.readOnly = readOnly;
        this.canMapFrom = canMapFrom;
        this.firstClassField = firstClassField;
        this.array = array;
        this.createdBy = createdBy;
        this.enum = enums;
        this.enumNames = enumNames;
        this.allowNewEnumValues = allowNewEnumValues;
        this.displayType = displayType;
    }
}
exports.PersonField = PersonField;
//# sourceMappingURL=personField.js.map